import React, { Component } from 'react';

class NotFound extends Component {

  render() {
    return (
      <div className="no-found">
       NoFound
      </div>
    );
  }

}

export default NotFound;
